import React, {Fragment} from 'react'
import styles from './GuidePageListItem.scss'
import {GuidePageViewer} from '../GuidePageViewer'
import {Icon} from 'common/Icon'
import {DeleteGuidePageDialogContainer} from '../../../dialogs/DeleteGuidePageDialog'
import p from 'prop-types'
import cx from 'classnames'

export class GuidePageListItem extends React.PureComponent {
  static propTypes = {
    guide: p.object.isRequired
  }

  static defaultProps = {
    editable: true
  }

  constructor (props) {
    super(props)

    this.state = {
      showDeleteDialog: false
    }
  }

  deleteClicked = () => {
    this.setState({showDeleteDialog: true})
  }

  titleClicked = (e) => {
    const {setExpanded, guide} = this.props
    // Only accept clicks that weren't clicking on something else
    if (e.target === e.currentTarget) {
      setExpanded(guide.id)
    }
  }

  hideDeleteDialog = () => {
    this.setState({showDeleteDialog: false})
  }

  render () {
    const {
      guide,
      expanded,
      dragHandleProps,
      hoverDisabled,
      isDragging,
      setExpanded,
      editable
    } = this.props
    const {showDeleteDialog} = this.state

    return (
      <Fragment>
        <div
          className={cx(styles.GuideTitle, expanded && styles.active, isDragging && styles.isDragging, !hoverDisabled && styles.hoverEffects)}
          onClick={expanded ? null : this.titleClicked}>
          <div className={styles.title} onClick={expanded ? null : this.titleClicked}>
            {guide.isLive && <Icon size={20} i='ios-wifi' className={styles.rightMargin} />}
            {guide.title || '(Untitled)'}
          </div>
          <div className={styles.controls}>
            {editable && <div className={cx(styles.guideControls, (expanded || isDragging) && styles.showGuideControls)}>
              <Icon i='md-trash' size={18} className={styles.control} onClick={this.deleteClicked} />
              <Icon i='md-move' size={18} className={cx(styles.control, expanded && styles.disabled)} {...dragHandleProps} />
            </div>}
          </div>
          {showDeleteDialog && <DeleteGuidePageDialogContainer
            guide={guide}
            expanded={expanded}
            setExpanded={setExpanded}
            onRequestClose={this.hideDeleteDialog} />}
        </div>

        {!editable && expanded && <div className={styles.GuideContent}>
          <GuidePageViewer guide={guide} />
        </div>}
      </Fragment>
    )
  }
}
